// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2MVNY","signatureButtonsRight":"ModalSign_signatureButtonsRight__3eZJ6"};